import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { formatInstant } from '@repo/date-time';
import { CalendarMonthIcon, ClockIcon, XIcon } from '@repo/icons';
import Input from '../Input/Input';
import { getLabels } from '../labels';
import InstantInputModal from './InstantInputModal';
const resolvePlaceholder = (mode, override, fromLabels) => {
    if (override !== undefined)
        return override;
    switch (mode) {
        case 'date':
            return fromLabels.date;
        case 'time':
            return fromLabels.time;
        case 'datetime':
            return fromLabels.dateTime;
        default: {
            const exhaustive = mode;
            return exhaustive;
        }
    }
};
export default function InstantInput({ testId, mode, value, onChange, min, max, disablePast = false, minuteStep, label, placeholder, size, state, disabled = false, clearable = false, className, onClear, }) {
    const calendarLabels = getLabels().calendar;
    const { clearAriaLabel } = getLabels().input;
    const [isOpen, setIsOpen] = useState(false);
    const displayValue = value !== undefined ? formatInstant(value, mode) : '';
    const handleOpen = useCallback(() => {
        if (disabled)
            return;
        setIsOpen(true);
    }, [disabled]);
    const handleOpenChange = (next) => setIsOpen(next);
    const resolvedPlaceholder = resolvePlaceholder(mode, placeholder, {
        date: calendarLabels.datePlaceholder,
        time: calendarLabels.timePlaceholder,
        dateTime: calendarLabels.dateTimePlaceholder,
    });
    const Icon = mode === 'time' ? ClockIcon : CalendarMonthIcon;
    const showClearButton = clearable && !disabled && value !== undefined;
    const handleClear = (event) => {
        event.stopPropagation();
        if (disabled)
            return;
        onClear?.();
    };
    return (_jsxs(_Fragment, { children: [className ? (_jsxs("div", { role: "button", tabIndex: disabled ? -1 : 0, onClick: handleOpen, "data-testid": testId.append('field'), className: className, children: [_jsx("span", { className: "min-w-0 truncate", children: value !== undefined ? displayValue : resolvedPlaceholder }), showClearButton && (_jsx("button", { type: "button", "aria-label": clearAriaLabel, className: "shrink-0 cursor-pointer border-none bg-transparent p-0", onClick: handleClear, "data-testid": testId.append('clear'), children: _jsx(XIcon, { size: 20 }) }))] })) : (_jsx(Input, { testId: testId.append('field'), label: label, size: size, state: state, disabled: disabled, readOnly: true, clearable: clearable, rightIcon: Icon, value: displayValue, placeholder: resolvedPlaceholder, onClear: onClear, onTriggerClick: handleOpen })), _jsx(InstantInputModal, { testId: testId.append('modal'), mode: mode, open: isOpen, onOpenChange: handleOpenChange, value: value, onChange: onChange, min: min, max: max, disablePast: disablePast, minDate: min, minuteStep: minuteStep })] }));
}
